import { render, staticRenderFns } from "./MyAccountLayout.vue?vue&type=template&id=a783f826&"
import script from "./MyAccountLayout.vue?vue&type=script&lang=ts&"
export * from "./MyAccountLayout.vue?vue&type=script&lang=ts&"
import style0 from "./MyAccountLayout.vue?vue&type=style&index=0&id=a783f826&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports